<template>
  <div class="header-container">
    <div class="header-logo">
      <a href="" >
        <img src="../../assets/img/logo/baiyiCollege.png" title="百驿学院">
      </a>
<!--      <div class="header-logo-container"></div>-->
    </div>
      <div class="search-container">
        <el-input placeholder="搜索课程..." v-model="search" clearable>
          <el-button slot="append" type="primary" icon="el-icon-search"  @click="titleSearch">立即搜索</el-button>
        </el-input>
      </div>
    <div class="login-info">
      <div class="header-login" v-if="phone===''">
        <router-link to="/login">
          <el-button type="text"  >
            <i class="iconfont iconlogin"></i>
            登录
          </el-button>
        </router-link>
        <router-link to="/login">
          <el-button type="text"   >
            <i class="iconfont iconadduser"></i>
            注册
          </el-button>
        </router-link>

        <!--        <el-button type="primary"  >-->
        <!--          <i class="iconfont iconlogin"></i>-->
        <!--          登录-->
        <!--        </el-button>-->
        <!--        <el-button type="primary"   >-->
        <!--          <i class="iconfont iconadduser"></i>-->
        <!--          注册</el-button>-->

      </div>
      <div class="right-menu" v-if="phone!==''">
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <img :src="img" class="user-avatar">
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">

              <el-dropdown-item>{{phone}}</el-dropdown-item>

            <router-link to="/">
              <el-dropdown-item>
                主页
              </el-dropdown-item>
            </router-link>
            <router-link to="/selfOrders">
              <el-dropdown-item>
                个人中心
              </el-dropdown-item>
            </router-link>

            <el-dropdown-item divided>
              <span style="display:block;" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

  </div>
</template>

<script>
import store from '@/store'
export default {
  name: "Header",
  data(){
    return{
      search:null,
      img:'',
      phone:'',
      nickName:''
    }
  },
  created(){
    this.img = this.baseUrl+store.getters.icon
    this.phone = store.getters.phone
  },
  methods:{
    titleSearch(){
      this.$emit('title-search',this.search)
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/?redirect=${this.$route.fullPath}`)
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss"  scoped>
  @import "../../assets/icon/iconfont.css";
  .header-container{
    display: flex;
    width: 1200px;
    margin: auto;
    height: 100%;
  }
  .header-logo{
    height: 100%;
    text-align: left;
  }
  .search-container{
    align-items: stretch;
    margin-left: 150px;
  }
  .el-input{
    padding: 10px;
    width: 500px;
  }
  .login-info{
    display: flex;
    float: right;
    margin-left: 100px;
  }
  .header-login{
    padding: 10px;
    margin-left: 30px;
    /*margin-right: 30px;*/

  }


  .right-menu {
    margin-left: 50px;
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue